import React from 'react';

const stats = [
  { value: '1K+', label: 'Creators' },
  { value: '340+', label: 'Certifications Issued' },
  { value: '85+', label: 'Production Houses' },
  { value: '40+', label: 'Projects Funded' },
];

export default function StatsSection() {
  return (
    <section className="mx-auto mt-8 max-w-6xl px-6">
      <div className="grid grid-cols-2 md:grid-cols-4 rounded-2xl bg-white shadow-sm border border-gray-200 overflow-hidden">
        {stats.map((item, idx) => (
          <div
            key={item.label}
            className={[
              'flex flex-col items-center justify-center py-8 px-4 text-center',
              idx !== stats.length - 1 ? 'md:border-r md:border-gray-200' : '',
              idx === 0 || idx === 2 ? 'border-r border-gray-200 md:border-r md:border-gray-200' : '',
              idx < 2 ? 'border-b border-gray-200 md:border-b-0' : '',
            ].join(' ')}
          >
            <div className="text-4xl sm:text-5xl font-extrabold tracking-tight text-gray-900">
              {item.value}
            </div>
            <div className="mt-2 text-xs sm:text-sm font-medium uppercase tracking-wide text-gray-500">
              {item.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

